module.exports = __webpack_public_path__ + "static/media/both.2fdcae9f.svg";